/** @jsx jsx */

import { ReactNode } from 'react';

import { Icon } from '@zapier/zinnia-icons';
import {
  Colors,
  Tooltip,
  TooltipFocusableTrigger,
} from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  iconWrapper: css`
    align-items: center;
    border-radius: 100px;
    border: 1px solid ${Colors.PrimeBlack};
    display: flex;
    height: 60px;
    justify-content: center;
    width: 60px;
    margin: 'auto';
  `,
};

export enum ButtonColor {
  primary = 'primary',
  secondary = 'secondary',
}

type Props = {
  hint: ReactNode;
};

function LockIcon({ hint }: Props) {
  return (
    <Tooltip
      allowMultiline={true}
      content={typeof hint === 'string' ? hint : ''}
      placement="left"
    >
      <TooltipFocusableTrigger>
        <div aria-label="Locked" css={Styles.iconWrapper}>
          <Icon color="GrayWarm7" name="actionLockFill" size={32} />
        </div>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}

export default LockIcon;
